// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { DefaultPage, Settings } from './'

export default {
  path: 'notifications',
  childRoutes: [{ path: 'default', component: DefaultPage }, { path: 'settings', component: Settings }],
};
